import { render, staticRenderFns } from "./DownloadDeliveryChoiceModal.vue?vue&type=template&id=bdc12820&"
import script from "./DownloadDeliveryChoiceModal.vue?vue&type=script&lang=js&"
export * from "./DownloadDeliveryChoiceModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports